import { MainLayout } from "@/components/layout/MainLayout";
import { Card, CardContent } from "@/components/ui/card";
import { useMarketplace } from "@/hooks/useMarketplace";
import { MarketplaceHeader } from "@/components/marketplace/MarketplaceHeader";
import { AvailableServices } from "@/components/marketplace/AvailableServices";
import { PremiumModules } from "@/components/marketplace/PremiumModules";
import { ComingSoonServices } from "@/components/marketplace/ComingSoonServices";
import { ModuleDetailDialog } from "@/components/marketplace/ModuleDetailDialog";

const STATIC_SERVICES = [
  {
    id: "agente-social",
    name: "Agente Social Kaiso",
    description: "Automatize suas redes sociais com IA. Postagens automáticas de diários, stories, anúncios inteligentes e insights. Conecte seu Instagram e Facebook.",
    price: "A partir de 29,90/mês",
    priceValue: 29.90,
    icon: "Share2",
    color: "bg-pink-500/10",
    iconColor: "text-pink-500",
    status: "available",
    route: "/social-agent",
    isPremium: true,
  },
  {
    id: "bot-ads-advanced",
    name: "Anúncios de bots Avançado",
    description: "Robô de anúncios mais avançados com machine learning para otimização automática de campanhas e testes A/B.",
    price: "79,90/mes",
    priceValue: 79.90,
    icon: "Target",
    color: "bg-blue-500/10",
    iconColor: "text-blue-500",
    status: "coming_soon",
  },
  {
    id: "contador-es",
    name: "Contador - Espanha",
    description: "Serviço de contabilidade especializado para restaurantes na Espanha. Gestão fiscal, IVA, declarações trimestrais e anuais com profissionais certificados.",
    price: "A partir de 99/mes",
    priceValue: 99.00,
    icon: "Calculator",
    color: "bg-emerald-500/10",
    iconColor: "text-emerald-500",
    status: "coming_soon",
  },
  {
    id: "delivery-fleet",
    name: "Frota de Entrega Parceria",
    description: "Conecte-se a frotas de entrega parceiras na sua região. Sem necessidade de manter entregadores próprios. Pague pela entrega realizada.",
    price: "Por entrega",
    priceValue: 0,
    icon: "Truck",
    color: "bg-amber-500/10",
    iconColor: "text-amber-500",
    status: "coming_soon",
  },
  {
    id: "bi-analytics",
    name: "BI e Analytics Avançado",
    description: "Dashboards avançados com inteligência de negócios. Previsão de demanda, análise de sazonalidade, benchmarks do setor e insights acionais.",
    price: "79,90/mes",
    priceValue: 79.90,
    icon: "BarChart3",
    color: "bg-purple-500/10",
    iconColor: "text-purple-500",
    status: "coming_soon",
  },
  {
    id: "seguro-restaurante",
    name: "Seguro Restaurante",
    description: "Proteja seu negócio com seguros especializados para restaurantes. Cobertura de equipamentos, responsabilidade civil e acidentes de trabalho.",
    price: "Sob consulta",
    priceValue: 0,
    icon: "Shield",
    color: "bg-red-500/10",
    iconColor: "text-red-500",
    status: "coming_soon",
  },
  {
    id: "suporte-premium",
    name: "Suporte Premium 24 horas por dia, 7 dias por semana",
    description: "Atendimento prioritário com tempo de resposta garantida. Gerente de contato dedicado, onboarding personalizado e treinamento para sua equipe.",
    price: "29,90/mes",
    priceValue: 29.90,
    icon: "Headphones",
    color: "bg-teal-500/10",
    iconColor: "text-teal-500",
    status: "coming_soon",
  },
];

const availableServices  = STATIC_SERVICES.filter(s => s.status === "available");
const comingSoonServices = STATIC_SERVICES.filter(s => s.status === "coming_soon");

export default function MarketplacePage() {
  const {
    modules, status, plan, trialDaysLeft, loading,
    selectedModule, setSelectedModule,
    subscribing, unsubscribing, totalMonthly,
    handleSubscribe, handleUnsubscribe, handleInterest,
  } = useMarketplace();

  return (
    <MainLayout>
      <div className="space-y-8" data-testid="marketplace-page">
        <MarketplaceHeader status={status} trialDaysLeft={trialDaysLeft} totalMonthly={totalMonthly} />

        <AvailableServices services={availableServices} />

        <PremiumModules
          modules={modules}
          loading={loading}
          status={status}
          trialDaysLeft={trialDaysLeft}
          onSelectModule={setSelectedModule}
        />

        <ComingSoonServices services={comingSoonServices} onInterest={handleInterest} />

        <Card className="bg-muted/30 border-dashed border-2 border-border/50">
          <CardContent className="py-8 text-center">
            <p className="text-muted-foreground text-sm">Novos serviços são regulares. Tem uma sugestão?</p>
            <p className="text-muted-foreground text-sm mt-1">
              Entre em contato pelo <span className="text-emerald-600 font-medium">WhatsApp Suporte</span> e nos conte!
            </p>
          </CardContent>
        </Card>

        <ModuleDetailDialog
          module={selectedModule}
          plan={plan}
          subscribing={subscribing}
          unsubscribing={unsubscribing}
          onSubscribe={handleSubscribe}
          onUnsubscribe={handleUnsubscribe}
          onClose={() => setSelectedModule(null)}
        />
      </div>
    </MainLayout>
  );
}
